module.exports = __webpack_public_path__ + "static/media/logo.9aa36be4.png";